module.exports = __webpack_public_path__ + "static/logo-541ae9c0d0eeb497eda35bdb7348964a.png";